define('components/photoset/layouts/fitColumn/processors/compact', [], function () {
    function Processor(options) {
        this.enable = ko.observable(options.enable).unwrap().default(true);
    }

    Processor.prototype.process = function (rows) {
        if (this.enable()) {
            ko.ignoreDependencies(function () {
                _(rows).invoke('compact');
            }, this);
        }
    };

    return Processor;
});